// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3948272c","160":"af516ad0","208":"76f33848","293":"73467e0d","516":"9afd933b","519":"cc6be675","917":"80a2f507","946":"f963fa13"}[chunkId] + ".chunk.js";
};